export default {
    apiUrl: 'https://saas.navixy.com/api-v2/',
    domain: location.hostname
}